export function getExpireTimeFromUrl(url: string) {
  try {
    const expires = new URL(url).searchParams.get('Expires');

    if (!expires) return '';

    return new Date(Number(expires) * 1000);
  } catch {
    return '';
  }
}

export function formatShareText(params: {
  fileName: string
  url: string
  expireText: string
}) {
  return [
    '文件分享',
    '',
    `文件名：${params.fileName}`,
    params.expireText ? `有效期：${params.expireText}` : '',
    '',
    `访问链接：${params.url}`,
  ].filter(Boolean).join('\n');
}

export async function copyText(text: string) {
  if (navigator.clipboard?.writeText && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');

  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  textarea.style.top = '-9999px';

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  const successful = document.execCommand('copy');

  document.body.removeChild(textarea);

  if (!successful) {
    throw new Error('复制失败');
  }
}